import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import {
  STR_AT_LEAST_ONE_IMAGE,
  STR_AVAILABLE_QUANTITY,
  STR_CATEGORY,
  STR_CROPS,
  STR_IMAGES,
  STR_INVALID_LOCATION,
  STR_INVALID_QUANTITY,
  STR_INVALID_TITLE,
  STR_INVALID_UNIT_PRICE,
  STR_ITEM_DESCRIPTION,
  STR_ITEM_LOCATION,
  STR_ITEM_TITLE,
  STR_LIVESTOCK,
  STR_MOQ,
  STR_POST_ITEM,
  STR_SUBMIT,
  STR_SUCCESS,
  STR_UNIT,
  STR_UNIT_PRICE
} from "../Strings";

export default function View({ data }) {

  const appContext = useContext(AppContext);
  const [loading, setLoading] = useState(false);

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'item',
      extraItem: data.uuid,
    })
  }

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
    return () => appContext.setShowOverlayLoader(false);
  }, [loading])

  return (
    <div
      onClick={view}
      style={{
        width: "100%",
        marginBottom: "18px",
        cursor: "pointer",
        borderRadius: "18px",
        overflow: "hidden",
        background: "var(--surfaceColor)",
        boxShadow: "var(--shadow3)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease"
      }}
      onMouseDown={e => e.currentTarget.style.transform = "scale(0.98)"}
      onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
    >

      {/* Image */}
      <div
        style={{
          width: "100%",
          height: "200px",
          overflow: "hidden",
          position: "relative"
        }}
      >
        <img
          src={CDN_URL + (data.img1 || data.img2 || data.img3)}
          alt={data.title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.4s ease"
          }}
        />

        {/* Category badge */}
        <div
          style={{
            position: "absolute",
            top: "12px",
            left: "12px",
            padding: "6px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: "600",
            background:
              data.category === "crop"
                ? "var(--primaryColor)"
                : "var(--secondaryColor)",
            color:
              data.category === "crop"
                ? "var(--onPrimaryColor)"
                : "var(--onSecondaryColor)"
          }}
        >
          Bidhaa
        </div>
      </div>

      {/* Content */}
      <div
        style={{
          padding: "14px 16px",
          display: "flex",
          flexDirection: "column",
          gap: "6px"
        }}
      >
        {/* Title */}
        <div
          style={{
            fontSize: "17px",
            fontWeight: "600",
            color: "var(--onSurfaceColor)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {data.title}
        </div>

        {/* Price */}
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            marginTop: "6px"
          }}
        >
          <div>
            <span
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "var(--primaryColor)"
              }}
            >
              {formatMoney(data.unitPrice)}
            </span>

            <span
              style={{
                fontSize: "14px",
                marginLeft: "6px",
                color: "var(--onSurfaceColor)",
                opacity: 0.7
              }}
            >
              TZS
            </span>
          </div>

          <div
            style={{
              fontSize: "13px",
              fontWeight: "600",
              textTransform: "uppercase",
              color: "var(--onSurfaceColor)",
              opacity: 0.6
            }}
          >
            {data.unit}
          </div>
        </div>
      </div>

    </div>
  )
}
